/***
 * Image lazy load
 * With in viewport detection
 */

import $ from 'jquery'
import inView from 'in-view'

let lazyLoad = {
    /**
     * Init lazy load
     */
    init () {
        inView('.lazyload').on('enter', this.process)
    },

    /**
     * Process element
     */
    process: element => {
        $(element).find('img')
            .each(
                (index, img) => {
                    $(img)
                        .one('load', () => $(img).addClass('ready'))
                        .attr('src', $(img).data('src'))
                        .attr('srcset', $(img).data('srcset'))
                        .removeAttr('data-src')
                        .removeAttr('data-srcset')
                }
            )
    }
}

export default lazyLoad;
